import React from 'react'
import {useCentralServices} from './useCentralServices'
import {SiteModel} from '../../../central/model'
import {selectMapperByKeys} from '../../mappers/util'

export const useSites = () => {
  const [loading, setLoading] = React.useState(false)
  const [sites, setSites] = React.useState<{value: string; label: string}[]>([])
  const {getSites} = useCentralServices()

  const getSitesFn = async (filters: SiteModel, page: number) => {
    try {
      setLoading(true)
      const sites = await getSites(filters, page)
      const mappedSites = selectMapperByKeys(sites, 'id', 'nombre')
      const filteredData = mappedSites.filter((item) => item.value !== '4EsB2NAAsDA=')
      setSites(filteredData)
    } catch (error) {
      console.error('Error fetching sites:', error)
    } finally {
      setLoading(false)
    }
  }

  const clearSites = () => {
    setSites([])
  }

  return {
    loading,
    sites,
    getSites: getSitesFn,
    clearSites,
  }
}
